import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import FrontEndApp from "./FrontEndApp";
const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/*" element={<FrontEndApp />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
